import { useMemo, useRef } from "react";

export function htmlStringToTextContent(
  htmlString: string,
  defaultString?: string,
  domParser?: DOMParser,
): string {
  if (!htmlString) {
    return defaultString ?? "";
  }
  const parser = domParser ?? new DOMParser();
  // If htmlString === null, this returns an HTML document with a <body> that contains the text 'null'
  const parsedHtml = parser.parseFromString(htmlString, "text/html");
  const parsedBody = parsedHtml.getElementsByTagName("body")[0];
  return (parsedBody?.textContent || defaultString) ?? "";
}

export function useHtmlStringToTextContent(
  htmlString: string,
  defaultString?: string,
) {
  const parserRef = useRef(new DOMParser());

  const textContent = useMemo(() => {
    return htmlStringToTextContent(
      htmlString,
      defaultString,
      parserRef.current,
    );
  }, [htmlString, defaultString, parserRef]);

  return textContent;
}
